import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import type StateService from 'garaje/services/state';
import urlBuilder from 'garaje/utils/url-builder';

export default class IntegrationTelemetryConfigService extends Service {
  @service declare state: StateService;

  @tracked hasDataForGlobal = true;
  @tracked hasDataForLocation = false;

  private _loadedForLocationId: string | null = null;

  ensureLoadedForLocation(locationId: string): void {
    if (locationId === this._loadedForLocationId) return;
    void this.loadForLocation(locationId);
  }

  async loadGlobal(preview?: string): Promise<void> {
    const companyId = String(this.state.currentCompany?.id);
    try {
      const url = urlBuilder.integrationTelemetry.configSupportedIntegrationsUrl(companyId, undefined, preview);
      const response = await fetch(url, { credentials: 'include' });
      if (!response.ok) return;
      const data = (await response.json()) as { hasData: boolean };
      this.hasDataForGlobal = data.hasData ?? true;
    } catch {
      // fallback: leave hasDataForGlobal = true so the dashboard stays visible
    }
  }

  async loadForLocation(locationId: string, preview?: string): Promise<void> {
    this._loadedForLocationId = locationId;
    this.hasDataForLocation = false;
    const companyId = String(this.state.currentCompany?.id);
    try {
      const url = urlBuilder.integrationTelemetry.configSupportedIntegrationsUrl(companyId, locationId, preview);
      const response = await fetch(url, { credentials: 'include' });
      if (!response.ok) return;
      const data = (await response.json()) as { hasData: boolean };
      this.hasDataForLocation = data.hasData ?? true;
    } catch {
      // fallback: leave hasDataForLocation = false so the tab stays hidden on error
    }
  }
}

declare module '@ember/service' {
  interface Registry {
    'integration-telemetry-config': IntegrationTelemetryConfigService;
  }
}
